var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostsSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 34,
    viewBox: "0 0 37 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.2823 3.0445L0.867188 11.9062L1.6728 14.6713L32.0879 5.80953L31.2823 3.0445Z",
    fill: "url(#paint0_linear_1714_119362)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50082 24.6066L0.0178838 9.22016C-0.0153515 9.10609 -0.0019088 8.98348 0.0552526 8.87932C0.112414 8.77515 0.208612 8.69796 0.322686 8.66473L30.0004 0.0177891C30.1145 -0.0153348 30.237 -0.00184645 30.3412 0.0552949C30.4453 0.112436 30.5225 0.208561 30.5559 0.32257L34.5274 13.9539L34.4045 13.9897L30.433 0.358383C30.4091 0.276982 30.3539 0.20836 30.2796 0.167551C30.2052 0.126742 30.1177 0.117073 30.0362 0.140663L0.35849 8.7876C0.277009 8.81134 0.208296 8.86648 0.167467 8.94089C0.126637 9.01529 0.117035 9.10287 0.140773 9.18435L4.62371 24.5708L4.50082 24.6066Z",
    fill: "url(#paint1_linear_1714_119362)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.957 14.0171C27.867 14.017 27.7794 13.9877 27.7074 13.9337C27.6353 13.8797 27.5827 13.8038 27.5575 13.7174L26.8056 11.1367C26.7748 11.0308 26.7874 10.917 26.8404 10.8203C26.8935 10.7236 26.9827 10.6519 27.0886 10.6209L29.6693 9.86903C29.7752 9.8383 29.889 9.85085 29.9857 9.90391C30.0823 9.95698 30.154 10.0462 30.185 10.1521L30.9369 12.7328C30.9676 12.8387 30.9551 12.9525 30.902 13.0492C30.849 13.1459 30.7597 13.2176 30.6539 13.2485L28.0732 14.0004C28.0355 14.0115 27.9963 14.0171 27.957 14.0171Z",
    fill: "url(#paint2_linear_1714_119362)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43136 9.26835C4.42363 9.24183 4.41444 9.21577 4.40383 9.19027C4.33167 9.01514 4.19734 8.87285 4.02665 8.79074C3.85596 8.70864 3.66094 8.69251 3.47908 8.74546C3.29722 8.79841 3.14134 8.9167 3.0414 9.07759C2.94145 9.23849 2.90449 9.43065 2.93762 9.61715C2.94227 9.64436 2.94847 9.67128 2.95618 9.69779C3.00292 9.85731 3.10007 9.99741 3.23309 10.0971C3.36612 10.1968 3.52785 10.2507 3.69408 10.2507C3.76666 10.2509 3.83887 10.2406 3.90849 10.22C4.10387 10.1629 4.26864 10.0307 4.36666 9.85228C4.46468 9.67388 4.48795 9.46388 4.43136 9.26835ZM3.87264 10.0971C3.7097 10.1444 3.53465 10.1252 3.38589 10.0436C3.23712 9.96202 3.12678 9.82477 3.07906 9.66195C3.07156 9.63543 3.06558 9.6085 3.06112 9.58131C3.03712 9.42765 3.0699 9.27051 3.15334 9.13927C3.23678 9.00804 3.36517 8.91168 3.5145 8.86823C3.66382 8.82478 3.82386 8.83721 3.96469 8.9032C4.10552 8.96918 4.21749 9.0842 4.27967 9.22675C4.29126 9.25178 4.30089 9.27767 4.30848 9.30419C4.35571 9.46713 4.33634 9.64217 4.25462 9.79084C4.1729 9.93952 4.03552 10.0497 3.87264 10.0971Z",
    fill: "url(#paint3_linear_1714_119362)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54705 9.81643C2.5061 9.67578 2.51003 9.52585 2.55831 9.38753C2.60658 9.24922 2.6968 9.1294 2.81639 9.04478C2.70435 9.03932 2.59263 9.06071 2.49053 9.10717C2.38843 9.15363 2.29892 9.22382 2.22944 9.31188C2.15996 9.39994 2.11252 9.50333 2.09109 9.61344C2.06966 9.72355 2.07485 9.83718 2.10623 9.94487C2.13761 10.0526 2.19426 10.1512 2.27148 10.2326C2.3487 10.3139 2.44424 10.3757 2.55015 10.4126C2.65605 10.4496 2.76926 10.4607 2.88033 10.4451C2.99141 10.4294 3.09713 10.3874 3.18871 10.3227C3.04238 10.3155 2.90193 10.2629 2.78692 10.1722C2.6719 10.0814 2.58806 9.95708 2.54705 9.81643Z",
    fill: "url(#paint4_linear_1714_119362)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4411 12.9882C22.4275 12.9392 22.4044 12.8934 22.373 12.8534C22.3417 12.8133 22.3027 12.7799 22.2585 12.7549C22.2142 12.73 22.1654 12.714 22.1149 12.7079C22.0645 12.7018 22.0133 12.7057 21.9643 12.7194L17.7154 13.9079L17.2578 14.0359H20.1314L20.589 13.9079L22.173 13.465C22.2717 13.4372 22.3554 13.3715 22.4057 13.2821C22.456 13.1927 22.4687 13.087 22.4411 12.9882Z",
    fill: "url(#paint5_linear_1714_119362)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4357 12.1008C19.408 12.0021 19.3422 11.9183 19.2528 11.868C19.1634 11.8177 19.0577 11.805 18.9589 11.8327L12.5833 13.6157C12.4942 13.641 12.4171 13.6972 12.3658 13.7743C12.3145 13.8514 12.2925 13.9443 12.3036 14.0362H13.9542L14.4124 13.9082L19.1676 12.5783C19.2664 12.5504 19.3501 12.4845 19.4004 12.395C19.4507 12.3055 19.4634 12.1997 19.4357 12.1008Z",
    fill: "url(#paint6_linear_1714_119362)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.852 13.9072H4.94018C4.82141 13.9074 4.70754 13.9546 4.62355 14.0386C4.53956 14.1226 4.49232 14.2365 4.49219 14.3552V32.6592C4.49232 32.778 4.53956 32.8919 4.62354 32.9759C4.70753 33.0599 4.82141 33.1071 4.94018 33.1072H35.852C35.9707 33.1071 36.0846 33.0599 36.1686 32.9759C36.2526 32.8919 36.2998 32.778 36.3 32.6592V14.3552C36.2998 14.2365 36.2526 14.1226 36.1686 14.0386C36.0846 13.9546 35.9707 13.9074 35.852 13.9072ZM36.172 32.6592C36.1719 32.7441 36.1382 32.8255 36.0782 32.8855C36.0182 32.9455 35.9368 32.9792 35.852 32.9792H4.94018C4.85532 32.9792 4.77395 32.9455 4.71395 32.8855C4.65394 32.8255 4.62022 32.7441 4.62019 32.6592V14.3552C4.62022 14.2704 4.65395 14.189 4.71395 14.129C4.77395 14.069 4.85533 14.0353 4.94018 14.0352H35.852C35.9368 14.0353 36.0182 14.069 36.0782 14.129C36.1382 14.189 36.1719 14.2704 36.172 14.3552V32.6592Z",
    fill: "url(#paint7_linear_1714_119362)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.94768 16.4042C7.79579 16.4042 7.6473 16.3591 7.52101 16.2747C7.39471 16.1903 7.29628 16.0704 7.23815 15.9301C7.18002 15.7897 7.16481 15.6353 7.19444 15.4863C7.22408 15.3374 7.29722 15.2005 7.40463 15.0931C7.51203 14.9857 7.64888 14.9126 7.79785 14.8829C7.94683 14.8533 8.10125 14.8685 8.24158 14.9266C8.38191 14.9848 8.50186 15.0832 8.58625 15.2095C8.67063 15.3358 8.71568 15.4843 8.71568 15.6362C8.71544 15.8398 8.63445 16.035 8.49048 16.179C8.3465 16.3229 8.15129 16.4039 7.94768 16.4042ZM7.94768 14.9962C7.8211 14.9962 7.69737 15.0337 7.59212 15.104C7.48687 15.1743 7.40484 15.2743 7.3564 15.3912C7.30796 15.5082 7.29529 15.6369 7.31998 15.761C7.34468 15.8852 7.40563 15.9992 7.49514 16.0887C7.58464 16.1782 7.69868 16.2392 7.82282 16.2639C7.94697 16.2886 8.07565 16.2759 8.1926 16.2274C8.30954 16.179 8.40949 16.097 8.47982 15.9917C8.55014 15.8865 8.58768 15.7627 8.58768 15.6362C8.58748 15.4665 8.52 15.3038 8.40002 15.1838C8.28003 15.0638 8.11736 14.9964 7.94768 14.9962Z",
    fill: "url(#paint8_linear_1714_119362)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75213 15.6356C6.75215 15.4891 6.79786 15.3463 6.8829 15.227C6.96794 15.1077 7.08807 15.0179 7.22656 14.9701C7.12052 14.9335 7.00727 14.9228 6.89626 14.9389C6.78524 14.9549 6.67966 14.9973 6.58832 15.0624C6.49698 15.1275 6.42252 15.2135 6.37115 15.3132C6.31977 15.4129 6.29297 15.5235 6.29297 15.6356C6.29297 15.7478 6.31977 15.8584 6.37115 15.9581C6.42252 16.0578 6.49698 16.1438 6.58832 16.2089C6.67966 16.274 6.78524 16.3164 6.89626 16.3324C7.00727 16.3484 7.12052 16.3377 7.22656 16.3011C7.08807 16.2534 6.96794 16.1636 6.8829 16.0443C6.79786 15.925 6.75215 15.7821 6.75213 15.6356Z",
    fill: "url(#paint9_linear_1714_119362)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0604 24.7101C10.9077 24.7099 10.7613 24.6492 10.6533 24.5412C10.5453 24.4332 10.4845 24.2868 10.4844 24.1341V22.4061C10.4844 22.2533 10.5451 22.1068 10.6531 21.9988C10.7611 21.8908 10.9076 21.8301 11.0604 21.8301C11.2131 21.8301 11.3596 21.8908 11.4677 21.9988C11.5757 22.1068 11.6364 22.2533 11.6364 22.4061V24.1341C11.6362 24.2868 11.5754 24.4332 11.4675 24.5412C11.3595 24.6492 11.2131 24.7099 11.0604 24.7101Z",
    fill: "url(#paint10_linear_1714_119362)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5955 24.7101C12.4428 24.7099 12.2964 24.6492 12.1884 24.5412C12.0804 24.4332 12.0197 24.2868 12.0195 24.1341V22.4061C12.0195 22.2533 12.0802 22.1068 12.1882 21.9988C12.2963 21.8908 12.4428 21.8301 12.5955 21.8301C12.7483 21.8301 12.8948 21.8908 13.0028 21.9988C13.1108 22.1068 13.1715 22.2533 13.1715 22.4061V24.1341C13.1713 24.2868 13.1106 24.4332 13.0026 24.5412C12.8946 24.6492 12.7482 24.7099 12.5955 24.7101Z",
    fill: "url(#paint11_linear_1714_119362)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1307 24.7101C13.978 24.7099 13.8316 24.6492 13.7236 24.5412C13.6156 24.4332 13.5549 24.2868 13.5547 24.1341V22.4061C13.5547 22.2533 13.6154 22.1068 13.7234 21.9988C13.8314 21.8908 13.9779 21.8301 14.1307 21.8301C14.2834 21.8301 14.43 21.8908 14.538 21.9988C14.646 22.1068 14.7067 22.2533 14.7067 22.4061V24.1341C14.7065 24.2868 14.6458 24.4332 14.5378 24.5412C14.4298 24.6492 14.2834 24.7099 14.1307 24.7101Z",
    fill: "url(#paint12_linear_1714_119362)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4979 24.7101C16.3452 24.7099 16.1988 24.6492 16.0908 24.5412C15.9828 24.4332 15.922 24.2868 15.9219 24.1341V22.4061C15.9219 22.2533 15.9826 22.1068 16.0906 21.9988C16.1986 21.8908 16.3451 21.8301 16.4979 21.8301C16.6506 21.8301 16.7971 21.8908 16.9052 21.9988C17.0132 22.1068 17.0739 22.2533 17.0739 22.4061V24.1341C17.0737 24.2868 17.013 24.4332 16.905 24.5412C16.797 24.6492 16.6506 24.7099 16.4979 24.7101Z",
    fill: "url(#paint13_linear_1714_119362)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0369 24.7101C17.8842 24.7099 17.7378 24.6492 17.6298 24.5412C17.5219 24.4332 17.4611 24.2868 17.4609 24.1341V22.4061C17.4609 22.2533 17.5216 22.1068 17.6296 21.9988C17.7377 21.8908 17.8842 21.8301 18.0369 21.8301C18.1897 21.8301 18.3362 21.8908 18.4442 21.9988C18.5522 22.1068 18.6129 22.2533 18.6129 22.4061V24.1341C18.6128 24.2868 18.552 24.4332 18.444 24.5412C18.336 24.6492 18.1896 24.7099 18.0369 24.7101Z",
    fill: "url(#paint14_linear_1714_119362)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5721 24.7101C19.4194 24.7099 19.273 24.6492 19.165 24.5412C19.057 24.4332 18.9963 24.2868 18.9961 24.1341V22.4061C18.9961 22.2533 19.0568 22.1068 19.1648 21.9988C19.2728 21.8908 19.4193 21.8301 19.5721 21.8301C19.7249 21.8301 19.8714 21.8908 19.9794 21.9988C20.0874 22.1068 20.1481 22.2533 20.1481 22.4061V24.1341C20.1479 24.2868 20.0872 24.4332 19.9792 24.5412C19.8712 24.6492 19.7248 24.7099 19.5721 24.7101Z",
    fill: "url(#paint15_linear_1714_119362)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9393 24.7101C21.7866 24.7099 21.6402 24.6492 21.5322 24.5412C21.4242 24.4332 21.3635 24.2868 21.3633 24.1341V22.4061C21.3633 22.2533 21.424 22.1068 21.532 21.9988C21.64 21.8908 21.7865 21.8301 21.9393 21.8301C22.092 21.8301 22.2385 21.8908 22.3466 21.9988C22.4546 22.1068 22.5153 22.2533 22.5153 22.4061V24.1341C22.5151 24.2868 22.4544 24.4332 22.3464 24.5412C22.2384 24.6492 22.092 24.7099 21.9393 24.7101Z",
    fill: "url(#paint16_linear_1714_119362)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4744 24.7101C23.3217 24.7099 23.1753 24.6492 23.0673 24.5412C22.9594 24.4332 22.8986 24.2868 22.8984 24.1341V22.4061C22.8984 22.2533 22.9591 22.1068 23.0671 21.9988C23.1752 21.8908 23.3217 21.8301 23.4744 21.8301C23.6272 21.8301 23.7737 21.8908 23.8817 21.9988C23.9897 22.1068 24.0504 22.2533 24.0504 22.4061V24.1341C24.0503 24.2868 23.9895 24.4332 23.8815 24.5412C23.7735 24.6492 23.6271 24.7099 23.4744 24.7101Z",
    fill: "url(#paint17_linear_1714_119362)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0096 24.7101C24.8569 24.7099 24.7105 24.6492 24.6025 24.5412C24.4945 24.4332 24.4338 24.2868 24.4336 24.1341V22.4061C24.4336 22.2533 24.4943 22.1068 24.6023 21.9988C24.7103 21.8908 24.8568 21.8301 25.0096 21.8301C25.1624 21.8301 25.3089 21.8908 25.4169 21.9988C25.5249 22.1068 25.5856 22.2533 25.5856 22.4061V24.1341C25.5854 24.2868 25.5247 24.4332 25.4167 24.5412C25.3087 24.6492 25.1623 24.7099 25.0096 24.7101Z",
    fill: "url(#paint18_linear_1714_119362)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3807 24.7101C27.228 24.7099 27.0816 24.6492 26.9736 24.5412C26.8656 24.4332 26.8049 24.2868 26.8047 24.1341V22.4061C26.8047 22.2533 26.8654 22.1068 26.9734 21.9988C27.0814 21.8908 27.2279 21.8301 27.3807 21.8301C27.5334 21.8301 27.68 21.8908 27.788 21.9988C27.896 22.1068 27.9567 22.2533 27.9567 22.4061V24.1341C27.9565 24.2868 27.8958 24.4332 27.7878 24.5412C27.6798 24.6492 27.5334 24.7099 27.3807 24.7101Z",
    fill: "url(#paint19_linear_1714_119362)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9158 24.7101C28.7631 24.7099 28.6167 24.6492 28.5087 24.5412C28.4008 24.4332 28.34 24.2868 28.3398 24.1341V22.4061C28.3398 22.2533 28.4005 22.1068 28.5085 21.9988C28.6166 21.8908 28.7631 21.8301 28.9158 21.8301C29.0686 21.8301 29.2151 21.8908 29.3231 21.9988C29.4311 22.1068 29.4918 22.2533 29.4918 22.4061V24.1341C29.4917 24.2868 29.4309 24.4332 29.3229 24.5412C29.215 24.6492 29.0685 24.7099 28.9158 24.7101Z",
    fill: "url(#paint20_linear_1714_119362)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.451 24.7101C30.2983 24.7099 30.1519 24.6492 30.0439 24.5412C29.9359 24.4332 29.8752 24.2868 29.875 24.1341V22.4061C29.875 22.2533 29.9357 22.1068 30.0437 21.9988C30.1517 21.8908 30.2982 21.8301 30.451 21.8301C30.6038 21.8301 30.7503 21.8908 30.8583 21.9988C30.9663 22.1068 31.027 22.2533 31.027 22.4061V24.1341C31.0268 24.2868 30.9661 24.4332 30.8581 24.5412C30.7501 24.6492 30.6037 24.7099 30.451 24.7101Z",
    fill: "url(#paint21_linear_1714_119362)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9641 31.1198H6.68C6.57735 31.1198 6.47891 31.079 6.40633 31.0064C6.33375 30.9338 6.29297 30.8354 6.29297 30.7327C6.29297 30.6301 6.33375 30.5316 6.40633 30.4591C6.47891 30.3865 6.57735 30.3457 6.68 30.3457H14.9641C15.0668 30.3457 15.1652 30.3865 15.2378 30.4591C15.3104 30.5316 15.3511 30.6301 15.3511 30.7327C15.3511 30.8354 15.3104 30.9338 15.2378 31.0064C15.1652 31.079 15.0668 31.1198 14.9641 31.1198Z",
    fill: "url(#paint22_linear_1714_119362)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3084 29.4557H9.33625C9.2336 29.4557 9.13516 29.4149 9.06258 29.3423C8.99 29.2698 8.94922 29.1713 8.94922 29.0687C8.94922 28.966 8.99 28.8676 9.06258 28.795C9.13516 28.7224 9.2336 28.6816 9.33625 28.6816H12.3084C12.411 28.6816 12.5095 28.7224 12.5821 28.795C12.6547 28.8676 12.6954 28.966 12.6954 29.0687C12.6954 29.1713 12.6547 29.2698 12.5821 29.3423C12.5095 29.4149 12.411 29.4557 12.3084 29.4557Z",
    fill: "url(#paint23_linear_1714_119362)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1455 17.7334H4.59375V17.8614H36.1455V17.7334Z",
    fill: "url(#paint24_linear_1714_119362)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1714_119362",
    x1: 7.18806,
    y1: 10.2005,
    x2: 9.26915,
    y2: 15.7588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1714_119362",
    x1: 7.13407,
    y1: 1.11485,
    x2: 29.3346,
    y2: 38.9342,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1714_119362",
    x1: 27.6495,
    y1: 10.0412,
    x2: 31.873,
    y2: 15.1685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1714_119362",
    x1: 3.24313,
    y1: 8.78443,
    x2: 4.80077,
    y2: 10.6755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1714_119362",
    x1: 2.30759,
    y1: 9.10774,
    x2: 3.7611,
    y2: 10.4996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1714_119362",
    x1: 18.3317,
    y1: 12.7654,
    x2: 18.887,
    y2: 15.3984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1714_119362",
    x1: 13.778,
    y1: 11.9188,
    x2: 14.8773,
    y2: 16.2213,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1714_119362",
    x1: 11.0643,
    y1: 14.7771,
    x2: 26.8821,
    y2: 46.5908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1714_119362",
    x1: 7.49705,
    y1: 14.9378,
    x2: 9.05479,
    y2: 16.8289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1714_119362",
    x1: 6.48587,
    y1: 14.9954,
    x2: 7.90716,
    y2: 16.1396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1714_119362",
    x1: 10.7224,
    y1: 21.9606,
    x2: 13.0611,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1714_119362",
    x1: 12.2576,
    y1: 21.9606,
    x2: 14.5963,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1714_119362",
    x1: 13.7927,
    y1: 21.9606,
    x2: 16.1315,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1714_119362",
    x1: 16.1599,
    y1: 21.9606,
    x2: 18.4986,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1714_119362",
    x1: 17.699,
    y1: 21.9606,
    x2: 20.0377,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1714_119362",
    x1: 19.2341,
    y1: 21.9606,
    x2: 21.5729,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1714_119362",
    x1: 21.6013,
    y1: 21.9606,
    x2: 23.94,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1714_119362",
    x1: 23.1365,
    y1: 21.9606,
    x2: 25.4752,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1714_119362",
    x1: 24.6716,
    y1: 21.9606,
    x2: 27.0104,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1714_119362",
    x1: 27.0427,
    y1: 21.9606,
    x2: 29.3815,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1714_119362",
    x1: 28.5779,
    y1: 21.9606,
    x2: 30.9166,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1714_119362",
    x1: 30.113,
    y1: 21.9606,
    x2: 32.4518,
    y2: 23.0963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1714_119362",
    x1: 8.16457,
    y1: 30.3808,
    x2: 8.27661,
    y2: 31.9725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1714_119362",
    x1: 9.72326,
    y1: 28.7167,
    x2: 9.98785,
    y2: 30.2713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1714_119362",
    x1: 11.113,
    y1: 17.7392,
    x2: 11.1139,
    y2: 18.0037,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#297DF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8F3FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostsSectionIcon);
export default __webpack_public_path__ + "static/media/costs-section-icon.a9f650295a0eab01660c4fa943e1ae30.svg";
export { ForwardRef as ReactComponent };